import {Pipe, PipeTransform} from '@angular/core';
import {ModelDto} from '../../../Models/Tasks/Checklists/Models/model.interface';

@Pipe({
  name: 'models',
  standalone: false
})
export class ModelsPipe implements PipeTransform {

  transform(items: ModelDto[], filter: {
    isAudit: boolean,
    local?: number,
    department?: number,
    category?: number
  }): ModelDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    items = items.filter((item) => item.activo);

    items = items.filter((item) => item.auditoria === (filter.isAudit ? 1 : 0));

    if (filter.local) {
      items = items.filter((item) => item.id_local == filter.local || !item.id_local);
    }

    if (filter.department) {
      items = items.filter((item) => item.id_departamento == filter.department);
    }

    if (filter.category) {
      items = items.filter((item) => item.id_partida == filter.category);
    }

    return items;

  }

}
